import { System } from '../../../data/types/system/system';
import { roundRealDistance } from '../../coordinates/coordinates';

export const getFuelAmountToTravel = (
  systemA: System,
  systemB: System,
): number => {
  return roundRealDistance(systemA.coordinates, systemB.coordinates);
};
